"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMuiTableCellOverrides = void 0;
var createMuiTableCellOverrides = function (_a) {
    var palette = _a.palette, spacing = _a.spacing, typography = _a.typography, shape = _a.shape;
    return ({
        root: {
            padding: spacing(4, 2),
            borderBottom: undefined,
            "&:not($paddingNone):not($paddingCheckbox):first-child": {
                paddingLeft: spacing(4),
            },
            "&:not($paddingNone):not($paddingCheckbox):last-child": {
                paddingRight: spacing(4),
            },
        },
        head: __assign(__assign({}, typography.caption), { color: palette.text.secondary }),
        stickyHeader: {
            backgroundColor: palette.background.paper,
        },
        body: {
            color: palette.text.primary,
            borderBottom: "1px solid " + palette.background.paper,
            // Radius only seems to work on table by applying both on tbody and cell
            "[class*='MuiTableRow-root']:first-child &": {
                "&:first-child": { borderTopLeftRadius: shape.borderRadius },
                "&:last-child": { borderTopRightRadius: shape.borderRadius },
            },
            "[class*='MuiTableRow-root']:last-child &": {
                borderBottom: "none",
                "&:first-child": { borderBottomLeftRadius: shape.borderRadius },
                "&:last-child": { borderBottomRightRadius: shape.borderRadius },
            },
        },
        paddingCheckbox: {
            padding: spacing(0, 0, 0, 2),
            width: spacing(10),
            "&:last-child": {
                paddingRight: spacing(4),
                width: spacing(12),
            },
        },
        sizeSmall: {
            padding: undefined,
            paddingTop: spacing(3),
            paddingBottom: spacing(3),
            "&:last-child": {
                paddingRight: undefined,
            },
            "&$head": {
                paddingTop: spacing(4),
                paddingBottom: spacing(4),
            },
            "&$paddingCheckbox": {
                padding: spacing(0, 2, 0, 4),
                "&:last-child": {
                    paddingLeft: spacing(2),
                    paddingRight: spacing(4),
                },
            },
        },
    });
};
exports.createMuiTableCellOverrides = createMuiTableCellOverrides;
//# sourceMappingURL=MuiTableCell.js.map